import React from 'react';
import { Spinner } from '@zapier/design-system';
import AccountActions from '../components/UniversalTopbar/AccountActions';
import { AccountsMenuContainer } from '../components/AccountsMenu';
import { LegacyButton } from '@zapier/design-system';
import { UniversalNavContext } from '../hooks/useUniversalNavContext';
const renderAccountsMenuContainerConfig = {
    shouldRender: (renderProps) => {
        return renderProps.isLoggedIn;
    },
    makeRenderer: (renderProps) => (props) => {
        const backToAppButton = !renderProps.currentUrl.includes('/app/') &&
            renderProps.canTopbarFitBackToAppButton && (React.createElement(UniversalNavContext.Consumer, null, (context) => (React.createElement(LegacyButton, { href: context.getFullyQualifiedURL('/app/assets/zaps'), id: "back-to-app", color: "brand" }, "My Zaps"))));
        return (React.createElement(React.Fragment, null,
            backToAppButton,
            React.createElement(AccountsMenuContainer, { currentAccountId: renderProps.currentAccountId, size: props.size })));
    },
};
const renderLoadingConfig = {
    shouldRender: (renderProps) => {
        return !renderProps.isLoggedIn && renderProps.isLoadingLoggedIn;
    },
    makeRenderer: () => () => {
        return (React.createElement("div", { "data-testid": "accounts-loader" },
            React.createElement(Spinner, { color: "dark" })));
    },
};
const renderSignUpOnlyConfig = {
    shouldRender: (renderProps) => {
        return renderProps.currentUrl.includes('/login');
    },
    makeRenderer: (renderProps) => (props) => {
        const isOnReauthenticate = renderProps.currentUrl.includes('/reauthenticate');
        return (React.createElement(AccountActions, { selectedHref: renderProps.currentUrl, shouldRenderSignIn: false, shouldRenderSignUp: !isOnReauthenticate, signupHref: renderProps.signupHref, size: props.size }));
    },
};
const renderSignInOnlyConfig = {
    shouldRender: (renderProps) => {
        return renderProps.currentUrl.includes('/sign-up');
    },
    makeRenderer: (renderProps) => (props) => {
        return (React.createElement(AccountActions, { loginHref: renderProps.loginHref, selectedHref: renderProps.currentUrl, shouldRenderSignIn: true, shouldRenderSignUp: false, size: props.size }));
    },
};
const renderOnboardingConfig = {
    shouldRender: (renderProps) => {
        return renderProps.currentUrl.includes('/onboarding');
    },
    makeRenderer: () => () => {
        return null;
    },
};
const configs = [
    renderSignUpOnlyConfig,
    renderSignInOnlyConfig,
    renderOnboardingConfig,
    renderAccountsMenuContainerConfig,
    renderLoadingConfig,
];
const findAccountsMenuRenderer = (renderProps) => {
    const foundConfig = configs.find((config) => {
        return config.shouldRender(renderProps);
    });
    return foundConfig && foundConfig.makeRenderer(renderProps);
};
export default findAccountsMenuRenderer;
//# sourceMappingURL=findAccountsMenuRenderer.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
